import React from "react";
import { TriangleAlert } from "lucide-react";

/**
 * FieldError — #1299. The sentence under a field that is missing or invalid.
 *
 * D55 (PR #841 review, B2): `DirectionA2.dc.html:168` draws a per-field error
 * at 12px/600, line-height 1.45, `#0F172A` (ink). D312 follows the board's
 * `CoachPlayerGoals.dc.html` instead (D259): `align-items:center`, line-height 1.5. D303 (#1299) amends D55 for
 * field errors: the alert red is on the indicators (the field's
 * `--nw-border-invalid` border and this glyph); the sentence itself stays ink.
 * `NewGoalSheet` shipped this shape first.
 *
 * `id` is the target of the field's `aria-describedby`. The text content is
 * exactly `children` (journey 32 asserts `toHaveText` on `m-overs-error`).
 */
export function FieldError({ id, testId, children }) {
  return (
    <p
      id={id}
      data-testid={testId}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        marginTop: 4,
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.5,
        color: "var(--nw-ink)",
      }}
    >
      <TriangleAlert size={14} color="var(--nw-alert)" strokeWidth={2} aria-hidden="true" style={{ flexShrink: 0 }} />
      <span>{children}</span>
    </p>
  );
}

export default FieldError;
